import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Input, Button } from 'semantic-ui-react';
import i18next from 'i18next';
import { AvailableDaysEditor } from '../../common';
import { editEntityField, saveBudgetGroup } from '../../../actions';
import currencyOptions from '../../../consts/CommonCurrency.json';

class BudgetGroupEditor extends Component {
    state = { predictedMonthly: 0 };

    handleSubmit = (event) => {
        this.props.saveBudgetGroup(this.props.company.id, this.props.entity);
        event.preventDefault();
    }

    render() {
        if (!this.props.entity) {
            return null;
        }

        const budget = this.props.entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <label>{i18next.t('name')}</label>
                    <input
                        placeholder={i18next.t('name')}
                        value={budget.name || ''}
                        onChange={({ target }) => this.props.editEntityField('name', target.value)}
                        required
                    />
                </Form.Field>

                <Form.Group widths='equal'>
                    <Form.Field>
                        <label>{i18next.t('dailyLimit')}</label>
                        <Input
                            fluid
                            label={{ basic: true, content: currencyOptions[this.props.company.currencyCode].symbol_native }}
                            labelPosition='right'
                            type='text'
                            placeholder={i18next.t('dailyLimit')}
                            required
                            value={budget.dailyLimit}
                            onChange={({ target }) => {
                                let { value } = target;
                                if (value) {
                                    value = parseInt(value, 10);
                                }
                                this.setState({ predictedMonthly: value ? value * 22 : value });
                                this.props.editEntityField('dailyLimit', value);
                            }}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>{i18next.t('monthlyLimit')}</label>
                        <Input
                            fluid
                            label={{ basic: true, content: currencyOptions[this.props.company.currencyCode].symbol_native }}
                            labelPosition='right'
                            type='text'
                            placeholder={this.state.predictedMonthly || i18next.t('monthlyLimit')}
                            disabled={Boolean(budget.id)}
                            required
                            value={budget.monthlyLimit}
                            onChange={({ target }) => {
                                let { value } = target;
                                if (value) value = parseInt(value, 10);
                                this.props.editEntityField('monthlyLimit', value);
                            }}
                        />
                    </Form.Field>
                </Form.Group>

                <Form.Field>
                    <label>{i18next.t('subsidy')}</label>
                    <Input
                        fluid
                        label={{ basic: true, content: '%' }}
                        labelPosition='left'
                        placeholder={i18next.t('subsidy')}
                        required
                        value={budget.subsidyValue || ''}
                        onChange={({ target }) => {
                            if (!target.value) {
                                this.props.editEntityField('subsidyValue', '');
                            } else {
                                const value = parseInt(target.value, 10);
                                if (value > 0 && value <= 100) {
                                    this.props.editEntityField('subsidyValue', value);
                                }
                            }
                        }}
                    />
                </Form.Field>

                <AvailableDaysEditor object={budget} onChange={this.props.editEntityField} />

                <Button primary type='submit' floated="right">
                    {i18next.t('save')}
                </Button>
            </Form>
        );
    }
}

BudgetGroupEditor.propTypes = {
    company: PropTypes.object,
    saveBudgetGroup: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object,
    
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;

    return { entity };
};

export default connect(mapStateToProps, { saveBudgetGroup, editEntityField })(BudgetGroupEditor);
